import {
  ChangeDetectionStrategy,
  Component,
  output,
  inject,
} from '@angular/core';

import {
  NewsletterFormData,
  NewsletterFormGroup,
} from '../../models/newsletter-form-data';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import {
  CheckboxWithLabelComponent,
  FormControlComponent,
  PrimengButtonDirective,
  PrimengInputTextDirective,
  ReCaptchaComponent,
} from '@web/shared/ui';
import { Button } from 'primeng/button';
import { InputText } from 'primeng/inputtext';
import { Route } from '@web/common';
import { Checkbox } from 'primeng/checkbox';
import { RegulationsCheckboxLabelComponent } from '../../ui/regulations-checkbox-label/regulations-checkbox-label.component';
import { PrivacyPolicyClauseComponent } from '../../ui/privacy-policy-clause/privacy-policy-clause.component';

@Component({
  selector: 'app-newsletter-form',
  imports: [
    ReactiveFormsModule,
    FormControlComponent,
    Button,
    InputText,
    PrimengInputTextDirective,
    PrimengButtonDirective,
    Checkbox,
    CheckboxWithLabelComponent,
    RegulationsCheckboxLabelComponent,
    PrivacyPolicyClauseComponent,
    ReCaptchaComponent,
  ],
  templateUrl: './newsletter-form.component.html',
  styleUrl: './newsletter-form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewsletterFormComponent {
  private readonly builder = inject(FormBuilder);

  protected readonly form!: NewsletterFormGroup;
  protected readonly submitClickEvent = output<NewsletterFormData>();
  protected readonly Route = Route;

  public constructor() {
    this.form = this.buildForm();
  }

  public handleSubmitClick(): void {
    this.submitClickEvent.emit(this.toModel());

    this.form.reset();
  }

  private toModel(): NewsletterFormData {
    const data = this.form.getRawValue();

    return new NewsletterFormData({
      email: data.email,
    });
  }

  private buildForm(): NewsletterFormGroup {
    /* prettier-ignore */
    return this.builder.group({
      email: this.builder.nonNullable.control<string>('', [Validators.required]),
      regulations: this.builder.nonNullable.control<boolean>(false, [Validators.required, Validators.requiredTrue]),
      recaptcha: this.builder.nonNullable.control<boolean>(false, [Validators.required, Validators.requiredTrue]),
    });
  }
}
